export default __webpack_public_path__ + "static/media/girl-meditating.ee24b4f5.jpg";